<script setup lang="ts">
import CloseIcon from '../../assets/icons/close-tiny.svg?component';
import UiButton from './UiButton.vue';

defineOptions({ name: 'UiDialogCloseButton' });

interface Props {
  disabled?: boolean;
  label?: string;
}

const { disabled = false, label = 'Close' } = defineProps<Props>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <div class="ui-dialog-close-button">
    <UiButton
      type="button"
      severity="secondary"
      variant="ghost"
      class="ui-dialog-close-button__button"
      :disabled="disabled"
      :aria-label="label"
      @click="emit('click')"
    >
      <template #icon>
        <CloseIcon />
      </template>
    </UiButton>
  </div>
</template>

<style scoped lang="scss">
.ui-dialog-close-button {
  position: absolute;
  top: $static-space-3;
  right: $static-space-3;
  z-index: 10;
  display: flex;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;

  &__button {
    width: 2.25rem;
    height: 2.25rem;
    padding: 0;
    color: var(--p-surface-500);
  }

  :deep(svg) {
    width: $static-text-sm;
    height: $static-text-sm;
  }
}
</style>
